var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.open)?_c('font-awesome-icon',{class:_vm.colorScheme[_vm.eyeColor].darkText,attrs:{"icon":_vm.eyeIcon}}):_c('font-awesome-icon',{class:_vm.colorScheme[_vm.eyeColor].darkText,attrs:{"icon":_vm.eyeSlashIcon}})}
var staticRenderFns = []

export { render, staticRenderFns }